import { Folder } from 'lucide-vue-next'
import type { App } from 'vue'
import { registerComponents } from './components'

export const createAssets = () => ({
  install: (app: App) => {
    registerComponents(app)
    app.getRouter().addRoute('organization', {
      path: 'assets',
      name: 'assets',
      meta: {
        head: { titleKey: 'assets.title' },
        nav: { icon: Folder, order: 12, section: 'nav.workspace' },
        crumbs: [{ labelKey: 'nav.workspace', to: { name: 'dashboard' } }, { labelKey: 'assets.title' }]
      },
      component: () => import('./pages/AssetsPage.vue')
    })
  }
})
